import { Option } from '~/components/Select';
import countryFlagEmoji from 'country-flag-emoji';
import { Country, State } from '~/types/Address';

function countryNameWithFlag(country: Country) {
  const emoji = countryFlagEmoji?.get(country.iso2).emoji;
  return emoji ? `${emoji} ${country.name}` : country.name;
}

// If the compiler is given a Country, you'll get an Option
// If the compiler is given a Maybe<Country>, you'll get a Maybe<Option>
function formatMaybeCountryToOption(country: Country, icon?: boolean): Option<string>;
function formatMaybeCountryToOption(country: null | undefined, icon?: boolean): null;
function formatMaybeCountryToOption(
  country: Country | null | undefined,
  icon?: boolean,
): Option<string> | null;
function formatMaybeCountryToOption(
  country: Country | null | undefined,
  icon = false,
): Option<string> | null {
  return country ? formatCountryToOption(country, icon) : null;
}

function formatCountryToOption(country: Country, icon = false): Option<string> {
  return {
    label: icon ? countryNameWithFlag(country) : country.name,
    value: country.iso2,
  };
}

function formatStateToOption(state: State): Maybe<Option> {
  if (!state) return null;

  return {
    label: state.name,
    value: state.iso,
  };
}

function formatStateToString(state: State): string {
  if (!state) return '';

  return state.name;
}

export {
  formatCountryToOption,
  countryNameWithFlag,
  formatMaybeCountryToOption,
  formatStateToString,
  formatStateToOption,
};
